import moment from 'moment'
import { getCopyWithContentTableColumn } from '@/utils/common/tableColumn'
import i18n from '@/locales'
import BrandIcon from '@/sections/BrandIcon'
// import { Manager } from '@/utils/manager'
// import { uuid } from '@/utils/utils'

export const getCloudEnvTableColumn = () => {
  return {
    field: 'cloud_env',
    title: i18n.t('bill.cost_conversion_env'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        const { is_public_cloud } = row
        if (is_public_cloud === 'true') {
          return i18n.t('cloud_env.public')
        } else if (is_public_cloud === 'false') {
          return i18n.t('cloud_env.private')
        } else if (is_public_cloud === 'onpremise') {
          return i18n.t('cloud_env.onpremise')
        }
        return i18n.t('bill.text_259')
      },
    },
  }
}

export const getEnableDateTableColumn = () => {
  return {
    field: 'enable_date',
    title: i18n.t('bill.text_162'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        let ret = moment(row.enable_date).format('YYYY-MM')
        if (row.enable_date_end) {
          ret = ret + ' ~ ' + moment(row.enable_date_end).format('YYYY-MM')
        }
        return ret
      },
    },
  }
}

export const getBrandTableColumn = () => {
  return {
    field: 'brand',
    title: i18n.t('bill.text_81'),
    minWidth: 100,
    slots: {
      default: ({ row }, h) => {
        if (row.brand && row.brand !== 'all') {
          return [<BrandIcon name={ row.brand } key={row.id} />]
        }
        return i18n.t('bill.text_12')
      },
    },
  }
}

export const getAccountTableColumn = () => {
  return getCopyWithContentTableColumn({
    field: 'cloudaccount_name',
    title: i18n.t('bill.text_60'),
    hideField: true,
    message: (row) => {
      return row.cloudaccount_name || i18n.t('bill.text_13', [i18n.t('bill.text_60')])
    },
    slotCallback: (row) => {
      return row.cloudaccount_name || i18n.t('bill.text_13', [i18n.t('bill.text_60')])
    },
  })
}

export const getCloudProividerTableColumn = () => {
  return getCopyWithContentTableColumn({
    field: 'cloudprovider_name',
    title: i18n.t('bill.text_233'),
    hideField: true,
    message: (row) => {
      return row.cloudprovider_name || i18n.t('bill.text_13', [i18n.t('dictionary.cloudprovider')])
    },
    slotCallback: (row) => {
      return row.cloudprovider_name || i18n.t('bill.text_13', [i18n.t('dictionary.cloudprovider')])
    },
  })
}

export const getOwnerTableColumn = () => {
  return getCopyWithContentTableColumn({
    field: 'owner',
    title: i18n.t('bill.subaccount'),
    hideField: true,
    message: (row) => {
      return row.owner || i18n.t('bill.text_13', [i18n.t('bill.subaccount')])
    },
    slotCallback: (row) => {
      return row.owner || i18n.t('bill.text_13', [i18n.t('bill.subaccount')])
    },
  })
}

export const getProjectDomainTableColumn = () => {
  return getCopyWithContentTableColumn({
    field: 'domain_filter',
    title: i18n.t('bill.text_76'),
    hideField: true,
    message: (row) => {
      return row.domain_filter || i18n.t('common_723')
    },
    slotCallback: (row) => {
      return row.domain_filter || i18n.t('common_723')
    },
  })
}

export const getRuleTypeColumn = () => {
  return {
    field: 'type',
    title: i18n.t('bill.policy_type'),
    formatter: ({ row }) => {
      if (row.type === 'resource' || row.user_rules) {
        return i18n.t('bill.resource_policy')
      } else {
        return i18n.t('bill.global_policy')
      }
    },
  }
}

export const getRatioTableColumn = () => {
  return {
    field: 'ratio',
    title: i18n.t('bill.cost_conversion_ratio'),
    minWidth: 100,
    slots: {
      default: ({ row }, h) => {
        if (row.type === 'resource' || row.user_rules) {
          return [<list-body-cell-popover text={i18n.t('common_701', [row.user_rules?.length || 0])} min-width="600px">
            <vxe-grid size="mini" border showOverflow={false} row-config={{ isHover: true }} column-config={{ resizable: false }} columns={userRulesColumns} data={row.user_rules || []} />
          </list-body-cell-popover>]
        }
        if (row.type === 'global' || !row.user_rules) {
          if (row.ratio === parseInt(row.ratio)) return `${row.ratio}`
          return `${row.ratio.toFixed(8)}`
        }
        return '-'
      },
    },
  }
}

export const getCurrencyAppliedTableColumn = () => {
  return {
    field: 'currency_applied',
    title: i18n.t('bill.application_bill'),
    minWidth: 100,
    slots: {
      default: ({ row }, h) => {
        if (!row.currency_applied) return i18n.t('bill.text_259')
        return i18n.t('bill.text_287', [row.currency_applied.replace('_', '').replace('*', '')])
      },
    },
  }
}

const userRulesColumns = [
  {
    field: 'product',
    title: i18n.t('bill.product_name'),
    formatter: ({ row }) => {
      if (row.other) return i18n.t('common.text00053')
      return (row.product_name && row.product_code) ? `${row.product_name}（${row.product_code}）` : row.product_name || row.product_code || i18n.t('common.text00053')
    },
  },
  {
    field: 'object',
    title: i18n.t('bill.discount_object'),
    formatter: ({ row }) => {
      if (!row.product_code) return '-'
      if (row.object === 'whole_order') {
        return i18n.t('bill.whole_order')
      }
      return '-'
    },
  },
  {
    field: 'region',
    title: i18n.t('bill.region'),
    slots: {
      default: ({ row }, h) => {
        if (!row.product_code) return '-'
        const regionList = row.regions || []
        if (!regionList.length) {
          return i18n.t('bill.unlimited')
        }
        return regionList.map(v => {
          return <a-tag class="mb-1 mt-1">{v.region || v}</a-tag>
        })
      },
    },
  },
  {
    field: 'duration',
    title: i18n.t('bill.order_duration'),
    formatter: ({ row }) => {
      if (!row.product_code) return '-'
      if (!row.duration) return i18n.t('bill.unlimited_duration')
      if (row.duration === 'month') return i18n.t('bill.monthly_pay')
      if (row.duration === 'year') return i18n.t('bill.annual_pay')
      const list = row.duration.split('_')
      if (list.length === 2) {
        return list[1] === 'month' ? i18n.t('bill.some_month', [list[0]]) : i18n.t('bill.some_year', [list[0]])
      }
      return row.duration
    },
  },
  {
    field: 'rate',
    title: i18n.t('bill.resource_ratio'),
    formatter: ({ row }) => {
      return `${i18n.t('bill.cost_conversion_ratio')}: ${row.rate}`
    },
  },
]

export const getUserRulesColumn = () => {
  return {
    field: 'user_rules',
    title: i18n.t('bill.cost_conversion_resource_info'),
    slots: {
      default: ({ row }, h) => {
        if (!row.user_rules) return '-'
        const columns = userRulesColumns
        return [<vxe-grid class="mb-2" data={row.user_rules || []} columns={columns} />]
      },
    },
  }
}

export const getPolicyProductI18n = (product) => {
  return product || i18n.t('common.text00053')
}
